import { useForm, UseFormProps } from 'react-hook-form'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'

export function useZodForm<TSchema extends z.ZodTypeAny>(
  schema: TSchema,
  options?: UseFormProps<z.infer<TSchema>>,
  mode: 'onSubmit' | 'onChange' = 'onChange',
  reValidateMode: 'onSubmit' | 'onChange' = 'onChange'
) {
  return useForm<z.infer<TSchema>>({
    resolver: zodResolver(schema),
    shouldFocusError: true,
    reValidateMode,
    mode,
    ...options
  })
}
